import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Batches info |||| Batches info',
            docP: 'Records',
            update: {
                action: 'Update',
                successMessage: 'Success',
                errorMessage: 'Error',
            },
            send: {
                action: 'Send',
                successMessage: 'Success',
                errorMessage: 'Error',
            },
            exportDoc: {
                action: 'Export',
                successMessage: 'File generation in progress. Find the file in the "Export files" journal',
                errorMessage: 'Error',
            },
            fields: {
                productionDate: 'Production date',
                creationDate: 'Creation date',
                status: 'Status',
            },
            enums: {
                status: {
                    NEW: 'NEW',
                    ERROR: 'ERROR',
                    SENT: 'SENT',
                    SENDING: 'SENDING',
                }
            }
        },
    },
};
